module.exports = __webpack_public_path__ + "static/media/recovery-logoideation2.d50c416e.png";